import { getElements } from "./selector.js"; // local functions

var manipulateClass = function manipulateClass(type, elements, classnames) {
  var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  elements = getElements(elements);
  classnames = classnames.split(" ");
  elements.forEach(function (element) {
    classnames.forEach(function (classname) {
      if (type == "toggle") {
        element.classList.toggle(classname, force);
      } else {
        element.classList[type](classname);
      }
    });
  });
};

var getElement = function getElement(element) {
  return typeof element === "string" ? document.querySelector(element) : element;
};
/*
  ------------------------------------------------------------------------------
  An extended implementation of Element.classList.add(): adds classname(s) to
  single or multiple elements

  @param {String|Element|NodeList|Array} elements Selector, single or multiple elements
  @param {String} classnames Space separated if multiple
*/


var addClass = function addClass() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  manipulateClass.apply(void 0, ["add"].concat(args));
};
/*
  ------------------------------------------------------------------------------
  An extended implementation of Element.classList.remove(): removes classname(s)
  from single or multiple elements

  @param {String|Element|NodeList|Array} elements Selector, single or multiple elements
  @param {String} classnames Space separated if multiple
*/


var removeClass = function removeClass() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  manipulateClass.apply(void 0, ["remove"].concat(args));
};
/*
  ------------------------------------------------------------------------------
  An extended implementation of Element.classList.remove(): toggles classname(s)
  from single or multiple elements

  @param {String|Element|NodeList|Array} elements Selector, single or multiple elements
  @param {String} classnames Space separated if multiple
  @param {Bool} [optional] force
*/


var toggleClass = function toggleClass() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  manipulateClass.apply(void 0, ["toggle"].concat(args));
};
/*
  ------------------------------------------------------------------------------
  Check if an element contains at least one classname

  @param {String|Element} elements Selector, single element
  @param {String} classnames Space separated if multiple
*/


var containsAnyClass = function containsAnyClass(element, classnames) {
  element = getElement(element);
  if (!element) return null;
  var contains = false;
  classnames.split(" ").some(function (classname) {
    contains = element.classList.contains(classname);
    return contains;
  });
  return contains;
};
/*
  ------------------------------------------------------------------------------
  Check if an element contains all classnames

  @param {String|Element} elements Selector, single element
  @param {String} classnames Space separated if multiple
*/


var containsAllClasses = function containsAllClasses(element, classnames) {
  element = getElement(element);
  if (!element) return null;
  var contains = false;
  classnames.split(" ").every(function (classname) {
    contains = element.classList.contains(classname);
    return contains;
  });
  return contains;
};
/*
  ------------------------------------------------------------------------------
*/


export { addClass, removeClass, toggleClass, containsAnyClass, containsAllClasses };